export default "__VITE_ASSET__Dz1x$AHx__"